export const STEPS = <const>[
  "PREVIEW",
  "LOCATION",
  "FORMAT",
  "FILLING",
  "DESIGN"
];
